import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import {
  FaLinkedinIn, FaGithub, FaTwitter, FaFacebookF, FaInstagram,
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaRegClock
} from 'react-icons/fa';

// Cache PWA install prompt across route changes (depuis aef32, adapté)
let cachedDeferredPrompt = null;
let cachedInstalled = false;

function Footer() {
  const currentYear = new Date().getFullYear();
  const companyName = "INFO COLAB";
  const addressLine1 = "1 impasse des écuries";
  const addressLine2 = "78000 Versailles, France";
  const fullAddress = `${addressLine1}, ${addressLine2}`;
  const phoneNumber = "+33 7 69 29 79 63";
  const emailAddress = "contact@infocolab.com";

  const socialLinks = [
    { name: "LinkedIn", url: "https://www.linkedin.com/in/info-colab-22b975372/", IconComponent: FaLinkedinIn },
    { name: "X", url: "https://x.com/Infocolab", IconComponent: FaTwitter },
    { name: "Instagram", url: "https://www.instagram.com/infocolab/", IconComponent: FaInstagram },
    { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61578094055697", IconComponent: FaFacebookF },
    // { name: "GitHub", url: "https://github.com/info-colab", IconComponent: FaGithub },
  ];

  const [deferredPrompt, setDeferredPrompt] = useState(cachedDeferredPrompt);
  const [installed, setInstalled] = useState(cachedInstalled);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      cachedDeferredPrompt = e;
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      cachedInstalled = true;
      setInstalled(true);
      cachedDeferredPrompt = null;
      setDeferredPrompt(null);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);

    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      cachedInstalled = true;
      setInstalled(true);
    }
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      cachedDeferredPrompt = null;
      setDeferredPrompt(null);
    }
  };

  return (
    <footer className="footer">
      <img src="/images/visuel/foot.jpg" alt="Visuel footer" className="footer-hero-img" />
      <div className="container footer-container">

        <div className="footer-content-grid">
          <div className="footer-column footer-about">
            <Link to="/" className="footer-logo-link">
              <img src="/images/logo.jpg" alt="Info Colab Logo Footer" className="footer-logo" />
            </Link>
            <p className="footer-about-text">
              Votre partenaire de confiance pour des solutions web innovantes et sur mesure.
            </p>
          </div>

          <div className="footer-column footer-quicklinks">
            <h4 className="footer-column-title">Navigation</h4>
            <ul className="footer-links-list">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/a-propos">À Propos</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/realisations">Réalisations</Link></li>
              <li><Link to="/tarifs">Tarifs</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column footer-contact-info">
            <h4 className="footer-column-title">Nous Contacter</h4>
            <address className="footer-contact-details">
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(fullAddress)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-item"
              >
                <FaMapMarkerAlt className="footer-contact-icon" />
                <span>
                  {addressLine1}<br />
                  {addressLine2}
                </span>
              </a>
              <a href={`mailto:${emailAddress}`} className="contact-item">
                <FaEnvelope className="footer-contact-icon" />
                <span>{emailAddress}</span>
              </a>
              <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="contact-item">
                <FaPhoneAlt className="footer-contact-icon" />
                <span>{phoneNumber}</span>
              </a>
              <div className="contact-item">
                <FaRegClock className="footer-contact-icon" />
                <span>Lundi - Vendredi : 9h00 - 18h00</span>
              </div>
            </address>
          </div>

          <div className="footer-column footer-social">
            <h4 className="footer-column-title">Suivez-nous</h4>
            <ul className="footer-social-list">
              {socialLinks.map(social => (
                <li key={social.name}>
                  <a href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.name} title={social.name}>
                    <social.IconComponent />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {(deferredPrompt && !installed) && (
          <div className="footer-install">
            <button
              onClick={handleInstallClick}
              aria-label="Installer l'application"
              className="footer-install-btn"
            >
              📲 Installer l'application
            </button>
            <div className="footer-install-hint">
              Ajoutez l’app sur votre écran d’accueil pour une expérience plus rapide.
            </div>
          </div>
        )}

        <div className="footer-bottom">
          <p className="footeropyright">
            © {currentYear} {companyName}. Tous droits réservés. Conçu avec
            <Link to="/jeux-secrets-info-colab" className="secret-heart-link" title="Zone secrète !">❤️</Link>
            à Versailles.
          </p>
          <ul className="footer-legal-links">
            <li><Link to="/mentions-legales">Mentions Légales</Link></li>
            <li><Link to="/politique-confidentialite">Politique de confidentialité</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;